import placeholder from '../../../../../../assests/img/placeholder_icon.svg';
import React from 'react';
import { ButtonWithIcon } from './ButtonWithIcon';
import { HideEyeIcon } from '../../../../../../assests/GmsIcons';

type HeaderSectionProps = {
    id?: string;
    config?: {
        showHeader: boolean;
        showTitle: boolean;
        titleText: string;
        titleLayout: 'Left, Below Logo' | 'Centre';
        logoUrl: string;
        showResetButton: boolean;
        resetButtonText: string;
        resetButtonShowIcon: boolean;
        resetButtonIconUrl?: string;
        resetButtonShowTooltip: boolean;
        showCloseButton: boolean;
        closeButtonText: string;
        closeButtonShowIcon: boolean;
        closeButtonIconUrl?: string;
        closeButtonShowTooltip: boolean;
    };
    isSelected?: boolean;
};

const HeaderSection = ({
    id,
    config = {
        showHeader: true,
        showTitle: true,
        titleText: 'VFD Builder',
        titleLayout: 'Centre',
        logoUrl: '',
        showResetButton: true,
        resetButtonText: 'Reset',
        resetButtonShowIcon: false,
        resetButtonIconUrl: '',
        resetButtonShowTooltip: false,
        showCloseButton: true,
        closeButtonText: 'Close',
        closeButtonShowIcon: false,
        closeButtonIconUrl: '',
        closeButtonShowTooltip: false
    },
    isSelected = false
}: HeaderSectionProps) => {
    const baseId = id || 'header-section';
    const isCenteredLayout = config.titleLayout === 'Centre';

    return (
        <div id={baseId} data-testid={baseId} className={`tw-relative tw-py-2 tw-px-6 tw-flex tw-justify-between tw-items-center tw-mt-2 tw-h-auto
                        ${isSelected ? 'tw-ring-2 tw-bg-[#DADBDD] tw-ring-blue-500' : 'tw-bg-[#F4F5F7]'}`}>
            {!config.showHeader && (
                <div className="tw-absolute tw-inset-0 tw-bg-[#F4F5F7] tw-flex tw-items-center tw-justify-center tw-z-10 tw-pointer-events-none">
                    <div className="tw-flex tw-items-center tw-gap-2 tw-text-[#6D788C]">
                        <HideEyeIcon />
                        <span className="tw-font-semibold tw-text-base" style={{ fontFamily: "'Noto Sans', sans-serif" }}>Header</span>
                    </div>
                </div>
            )}
            {isCenteredLayout ? (
                <>
                    {/* Logo on left */}
                    <div id={`${baseId}-logo-wrapper`} className="tw-w-20 tw-flex tw-items-center tw-justify-center">
                        <img id={`${baseId}-logo`} src={config.logoUrl || placeholder} alt="" className="tw-max-w-full tw-max-h-full" />
                    </div>

                    {/* Title in center */}
                    {config.showTitle && (
                        <h2 id={`${baseId}-title`} className="tw-text-xl tw-text-[#172B4D] tw-font-semibold tw-flex-1 tw-text-center tw-truncate tw-max-w-xs" title={config.titleText}>
                            {config.titleText}
                        </h2>
                    )}

                    {/* Buttons on right */}
                    <div id={`${baseId}-buttons`} className="tw-flex tw-gap-2">
                        {config.showResetButton && (
                            <ButtonWithIcon
                                id={`${baseId}-reset-btn`}
                                text={config.resetButtonText}
                                showIcon={config.resetButtonShowIcon}
                                iconUrl={config.resetButtonIconUrl}
                                showTooltip={config.resetButtonShowTooltip}
                                tooltipText="Reset the configuration"
                            />
                        )}

                        {config.showCloseButton && (
                            <ButtonWithIcon
                                id={`${baseId}-close-btn`}
                                text={config.closeButtonText}
                                showIcon={config.closeButtonShowIcon}
                                iconUrl={config.closeButtonIconUrl}
                                showTooltip={config.closeButtonShowTooltip}
                                tooltipText="Close the configuration"
                            />
                        )}
                    </div>
                </>
            ) : (
                // Left Below Logo layout - Image 2
                <>
                    <div id={`${baseId}-left-section`} className="tw-space-y-3">
                        {/* Logo with title below */}
                        <div id={`${baseId}-logo-wrapper`} className="tw-w-20 tw-flex tw-items-center tw-justify-center">
                            <img id={`${baseId}-logo`} src={config.logoUrl || placeholder} alt=""  className="tw-max-w-full tw-max-h-full" loading='lazy' />
                        </div>

                        {config.showTitle && (
                            <h2 id={`${baseId}-title`} className="tw-text-base tw-text-[#172B4D] tw-font-semibold tw-truncate tw-max-w-xs" title={config.titleText}>
                                {config.titleText}
                            </h2>
                        )}
                    </div>

                    {/* Buttons on right */}
                    <div id={`${baseId}-buttons`} className="tw-flex tw-gap-2">
                        {config.showResetButton && (
                            <ButtonWithIcon
                                id={`${baseId}-reset-btn`}
                                text={config.resetButtonText}
                                showIcon={config.resetButtonShowIcon}
                                iconUrl={config.resetButtonIconUrl}
                                showTooltip={config.resetButtonShowTooltip}
                                tooltipText="Reset the configuration"
                            />
                        )}

                        {config.showCloseButton && (
                            <ButtonWithIcon
                                id={`${baseId}-close-btn`}
                                text={config.closeButtonText}
                                showIcon={config.closeButtonShowIcon}
                                iconUrl={config.closeButtonIconUrl}
                                showTooltip={config.closeButtonShowTooltip}
                                tooltipText="Close the configuration"
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default HeaderSection;